var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 13,
    viewBox: "0 0 24 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.66671C13.48 5.66671 14.6667 4.46671 14.6667 3.00004C14.6667 1.53337 13.48 0.333374 12 0.333374C10.5333 0.333374 9.33333 1.53337 9.33333 3.00004C9.33333 4.46671 10.5333 5.66671 12 5.66671ZM17.3333 5.66671C18.8133 5.66671 20 4.46671 20 3.00004C20 1.53337 18.8133 0.333374 17.3333 0.333374C16.8533 0.333374 16.4133 0.466707 16.0267 0.693374C16.4267 1.37337 16.6667 2.16004 16.6667 3.00004C16.6667 3.84004 16.4267 4.62671 16.0267 5.30671C16.4133 5.53337 16.8667 5.66671 17.3333 5.66671ZM12 7.26671C9.77333 7.26671 5.33333 8.37337 5.33333 10.6V12.3334H18.6667V10.6C18.6667 8.37337 14.2267 7.26671 12 7.26671ZM6.66667 4.33337H4V1.66671H2.66667V4.33337H0V5.66671H2.66667V8.33337H4V5.66671H6.66667V4.33337ZM18.9733 7.41337C19.9733 8.21337 20.6667 9.25337 20.6667 10.6V12.3334H24V10.6C24 8.85337 21.24 7.78671 18.9733 7.41337Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.b9841097bbc99b8a05b7e50d9dd7e1a7.svg";
export { ForwardRef as ReactComponent };